<template>
  <div class="notification-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true">
<!--        <el-form-item style="float: right;">-->
<!--          <el-button type="primary" icon="el-icon-plus" @click="openSendDialog">发送消息</el-button>-->
<!--        </el-form-item>-->
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" width="130">
          <template slot-scope="{ row }">
            <el-tag :type="typeTagType(row.type)" size="small">{{ typeText(row.type) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="180"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="280" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userId" label="接收用户ID" width="120" align="center"></el-table-column>
        <el-table-column label="发送时间" width="170">
          <template slot-scope="{ row }">
            {{ formatTime(row.createdAt) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 发送消息弹窗 -->
    <el-dialog title="发送消息" :visible.sync="sendVisible" width="550px" @close="resetSendForm">
      <el-form ref="sendForm" :model="sendForm" :rules="sendRules" label-width="100px">
        <el-form-item label="消息类型" prop="type">
          <el-select v-model="sendForm.type" placeholder="请选择类型" style="width:100%">
            <el-option label="上新通知" value="new_product"></el-option>
            <el-option label="领取成功" value="claim_success"></el-option>
            <el-option label="核销成功" value="verify_success"></el-option>
            <el-option label="过期提醒" value="expire_warning"></el-option>
            <el-option label="温馨提示" value="tip"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="sendForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="sendForm.content" type="textarea" :rows="4" placeholder="请输入消息内容"></el-input>
        </el-form-item>
        <el-form-item label="目标社区">
          <el-select v-model="sendForm.communityId" placeholder="全平台（不选）" clearable filterable style="width:100%">
            <el-option v-for="c in communities" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
          <div style="font-size:12px;color:#909399;margin-top:4px;">不选择社区则默认发送给全平台用户</div>
        </el-form-item>
        <el-form-item label="指定用户">
          <el-input
            v-model="userIdsInput"
            placeholder="用户ID，多个用逗号分隔"
            style="width:100%"
          ></el-input>
          <div style="font-size:12px;color:#909399;margin-top:4px;">留空则按社区/全平台推送</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="sendVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doSend">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getNotificationList, sendNotification } from '@/api/notification'
import { getCommunityList } from '@/api/community'

export default {
  name: 'NotificationList',
  data() {
    return {
      tableData: [],
      communities: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      sendVisible: false,
      submitting: false,
      sendForm: { type: '', title: '', content: '', communityId: null },
      userIdsInput: '',
      sendRules: {
        type: [{ required: true, message: '请选择消息类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadCommunities()
    this.loadData()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getCommunityList('', 1, 100)
        const list = res.records || res.list || res.items || res || []
        this.communities = Array.isArray(list) ? list : []
      } catch (e) {}
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getNotificationList(this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    typeText(t) {
      const map = {
        new_product: '上新通知',
        claim_success: '领取成功',
        verify_success: '核销成功',
        expire_warning: '过期提醒',
        tip: '温馨提示'
      }
      return map[t] || t || '-'
    },
    typeTagType(t) {
      const map = {
        new_product: 'success',
        claim_success: 'primary',
        verify_success: 'warning',
        expire_warning: 'danger',
        tip: 'info'
      }
      return map[t] || ''
    },
    openSendDialog() {
      this.sendForm = { type: '', title: '', content: '', communityId: null }
      this.userIdsInput = ''
      this.sendVisible = true
    },
    resetSendForm() {
      this.$refs.sendForm && this.$refs.sendForm.resetFields()
    },
    doSend() {
      this.$refs.sendForm.validate(async valid => {
        if (!valid) return
        const userIds = this.userIdsInput
          ? this.userIdsInput.split(',').map(s => Number(s.trim())).filter(Boolean)
          : null
        this.submitting = true
        try {
          await sendNotification(
            this.sendForm.type,
            this.sendForm.title,
            this.sendForm.content,
            this.sendForm.communityId,
            userIds
          )
          this.$message.success('消息发送成功')
          this.sendVisible = false
          this.loadData()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' }
  }
}
</script>

<style scoped>
.notification-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
